import { render } from "./SQLCheatSheet.vue?vue&type=template&id=492cf002&scoped=true"
const script = {}

import "./SQLCheatSheet.vue?vue&type=style&index=0&id=492cf002&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492cf002"]])

export default __exports__